var React = require('react');

function MoeDelete (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"d":"M41.654 58.898H11.8V17.425h29.853v41.472zM17.61 12.425h18.235V5.81H17.61v6.618zm23.235 0V.81H12.61v11.617H.993v5H6.8v46.47h39.853v-46.47h5.809v-5H40.845z","key":0}),React.createElement("path",{"d":"M18.418 52.28h5V24.044h-5zM30.037 52.28h5V24.044h-5z","key":1})]));
}

MoeDelete.defaultProps = {"width":"53","height":"64"};

module.exports = MoeDelete;

MoeDelete.default = MoeDelete;
